"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentEntityPanel = exports.ContentEntityPanelDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cn_1 = require("../../utils/cn");
var content_node_1 = require("./content-node");
var content_entity_titles_1 = require("./content-entity-titles");
var height_clip_1 = require("../elements/height-clip");
var cls = (0, cn_1.classNames)('content-entity-panel');
exports.ContentEntityPanelDefaultProps = {
  clipHeight: 340
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitlesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n    ", ";\n  "], ["\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(2), theme_1.theme.H_DOT_BG_END())
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    border-bottom: 1px solid ", ";\n    margin-bottom: ", ";\n  "], ["\n    padding: ", " ", " ", ";\n    border-bottom: 1px solid ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5), theme_1.theme.COLOR('line-sidebar'), theme_1.theme.UNIT(4))
});
var ClipStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Clip: (0, styled_components_1.default)(height_clip_1.HeightClip)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ClipStyles),
  Body: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Titles: (0, styled_components_1.default)(content_entity_titles_1.ContentEntityTitles)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  Intro: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Content: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
var ContentEntityPanel = function (props) {
  var className = props.className,
    clipHeight = props.clipHeight,
    entity = props.entity;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Clip, {
    maxHeight: clipHeight
  }, react_1.default.createElement(My.Body, {
    className: cls.sub('body')
  }, react_1.default.createElement(My.Titles, {
    allowNameForTitle: true,
    entity: entity
  }), entity.intro && react_1.default.createElement(My.Intro, {
    entity: entity.intro
  }), react_1.default.createElement(My.Content, {
    entity: entity.content
  }))));
};
exports.ContentEntityPanel = ContentEntityPanel;
exports.ContentEntityPanel.cls = cls;
exports.ContentEntityPanel.defaultProps = exports.ContentEntityPanelDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;